<template>
  <section class="section">
    <div class="container" style="margin-top:0.75rem;">
      <div
        ref="searchResults"
        class="columns is-multiline is-mobile"
        v-if="!isAlbumLoading && albums.length > 0"
      >
        <div class="column is-4">
          <span
            class="is-size-5-desktop is-size-6-mobile has-text-grey"
            v-if="pageType !== 'bookmarks'"
          >
            Resultados:
          </span>
          <span class="is-size-5-desktop is-size-6-mobile has-text-grey" v-else>
            Favoritos</span
          >
        </div>
        <div class="column is-6 has-text-right ">
          <span class="has-text-grey-light is-size-6">
            {{ albums.length }} producto(s)
          </span>
        </div>
        <div class="column is-2 has-text-left" @click="onClickUpdateSettings">
          <b-tooltip
            type="is-light"
            label="cambiar vista"
            position="is-top"
            :active="!isMobile"
          >
            <span
              style="cursor: pointer;"
              v-text="settings.panelType === 'card' ? '📚' : '📖'"
            ></span>
          </b-tooltip>
        </div>
      </div>
      <!-- Album List -->
      <transition name="list" mode="out-in">
        <div
          class="columns is-multiline is-mobile"
          v-if="!isAlbumLoading && displayedAlbums.length > 0"
          :key="pageType"
        >
          <div
            class="column"
            :class="[
              settings.panelType === 'card'
                ? 'is-3-widescreen is-3-desktop is-4-tablet'
                : 'is-4-widescreen  is-4-desktop is-6-tablet is-12-mobile'
            ]"
            v-for="album in displayedAlbums"
            :key="album.id"
          >
            <!-- Card Panel  -->
            <div class="card" v-if="settings.panelType === 'card'">
              <div class="card-image">
                <figure class="image is-square has-text-centered">
                  <a @click="onClickAlbumName(album)">
                    <img
                      loading="lazy"
                      :src="album.image_url | image(250)"
                      :alt="album.name"
                    />
                  </a>
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content overflow-content">
                    <div
                      :title="album.name"
                      class="title is-size-6-widescreen is-size-6-desktop album-name"
                    >
                      <a @click="onClickAlbumName(album)">{{ album.name }}</a>
                    </div>
                    <div class="subtitle is-5 has-text-weight-semibold">
                      <div>{{ album.price | priceFormat }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <a
                  :href="album.buy_url"
                  target="_blank"
                  class="card-footer-item"
                >
                  🛒
                </a>
                <a
                  class="heart card-footer-item"
                  @click="clickBookmarkAlbum(album)"
                >
                  <b-tooltip
                    type="is-light"
                    :label="
                      isInBookmark(album.name)
                        ? 'quitar de favoritos'
                        : 'añadir a favoritos'
                    "
                    position="is-top"
                    :active="!isMobile"
                  >
                    <span
                      class="fas fa-lg is-size-5 bookmarkIcon"
                      :class="[
                        {
                          favorite: isInBookmark(album.name)
                        },
                        settings.bookmarkIcon
                      ]"
                    ></span>
                  </b-tooltip>
                </a>
                <a @click="onClickAlbumName(album)" class="card-footer-item">
                  <b-tooltip
                    type="is-light"
                    label="Comparar precios"
                    position="is-top"
                    :active="!isMobile"
                  >
                    💱
                  </b-tooltip>
                </a>
              </footer>
            </div>
            <!-- Media Panel-->
            <article
              style="align-items: center;"
              class="media media-wrap"
              v-if="settings.panelType === 'media'"
            >
              <a @click="onClickAlbumName(album)">
                <figure class="media-left">
                  <img
                    loading="lazy"
                    class="image is-128x128"
                    :src="album.image_url | image(128)"
                    :alt="album.name"
                  />
                </figure>
              </a>
              <div class="media-content">
                <div class="content overflow-content">
                  <div>
                    <strong
                      ><a @click="onClickAlbumName(album)">{{
                        album.name
                      }}</a></strong
                    >
                  </div>
                  <div class="subtitle is-5 has-text-weight-semibold">
                    {{ album.price | priceFormat }}
                  </div>
                </div>
                <div class="level is-mobile">
                  <div class="level-left">
                    <a
                      class="level-item"
                      :href="album.buy_url"
                      target="_blank"
                      rel="nofollow noreferrer noopener"
                    >
                      <span class="is-5">🛒</span>
                    </a>
                    <a class="level-item" @click="clickBookmarkAlbum(album)">
                      <b-tooltip
                        type="is-light"
                        :label="
                          isInBookmark(album.name)
                            ? 'quitar de favoritos'
                            : 'añadir a favoritos'
                        "
                        position="is-top"
                        :active="!isMobile"
                      >
                        <span
                          class="fas bookmarkIcon is-size-5"
                          :class="[
                            {
                              favorite: isInBookmark(album.name)
                            },
                            settings.bookmarkIcon
                          ]"
                        ></span>
                      </b-tooltip>
                    </a>
                    <b-button
                      class="level-item"
                      @click="onClickAlbumName(album)"
                    >
                      Comparar
                    </b-button>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </transition>
      <!-- Loading animation -->
      <div class="columns is-mobile" v-if="isAlbumLoading">
        <div class="column loading">
          <b-loading
            :is-full-page="false"
            :active.sync="isAlbumLoading"
            :can-cancel="false"
          ></b-loading>
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="columns is-multiline is-mobile"
        v-if="!isAlbumLoading && albums.length > 0"
      >
        <div class="column is-12" v-if="albums.length > 0">
          <hr />
          <b-pagination
            :total="albums.length"
            :current.sync="current"
            :order="order"
            :size="size"
            :simple="isSimple"
            :rounded="isRounded"
            :per-page="settings.perPage"
            @change="onPageChange"
            aria-next-label="Siguiente"
            aria-previous-label="Anterior"
          >
          </b-pagination>
        </div>
      </div>
      <!-- No Bookmark message-->
      <template v-if="pageType === 'bookmarks' && !albums.length">
        <div class="columns is-multiline is-mobile">
          <div class="column">
            <h3 class="title is-4 has-text-centered">
              No has guardado favoritos
            </h3>
          </div>
        </div>
      </template>
      <!-- Search results message -->
      <template v-if="searchFailed && !isAlbumLoading">
        <div class="columns is-multiline is-mobile">
          <div class="column">
            <h3 class="title is-4 has-text-centered">Sin resultados.</h3>
            <h3 class="title is-4 has-text-centered">
              Prueba con otras palabras
            </h3>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: "AlbumList",
  data() {
    return {
      current: 1,
      order: "is-centered",
      size: "",
      isSimple: false,
      isRounded: false
    };
  },
  props: {
    albums: {
      type: Array,
      required: true
    },
    pageType: {
      type: String,
      required: true
    },
    isAlbumLoading: {
      type: Boolean,
      required: true
    },
    searchFailed: {
      type: Boolean,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    clickBookmarkAlbum: {
      type: Function,
      required: true
    },
    isInBookmark: {
      type: Function,
      required: true
    }
  },
  computed: {
    displayedAlbums() {
      return this.paginate(this.albums);
    }
  },
  watch: {
    albums(val, oldVal) {
      if (val !== oldVal) {
        this.current = 1;
      }
    }
  },
  methods: {
    paginate(albums) {
      let current = this.current;
      let perPage = this.settings.perPage;
      let from = current * perPage - perPage;
      let to = current * perPage;
      return albums.slice(from, to);
    },
    onClickUpdateSettings() {
      const settingValue =
        this.settings.panelType === "card" ? "media" : "card";
      this.$emit("clickUpdateSettings", "panelType", settingValue);
    },
    onClickAlbumName(album) {
      this.$emit("clickAlbumName", album);
    },
    onPageChange() {
      this.$refs.searchResults.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }
  }
};
</script>
